(() => {
  const root = document.querySelector('[data-mens-sale]');
  if (!root) return;
  const grid = root.querySelector('[data-sale-grid]');
  const controls = root.querySelector('[data-sale-controls]');
  const count = root.querySelector('[data-sale-count]');
  const selects = Object.fromEntries(['brand','style','fit','sort'].map(key => [key,root.querySelector(`[data-sale-${key}]`)]));
  const keys = {size:'uk_size',brand:'sale_brand',style:'sale_style',fit:'sale_fit',sort:'sale_sort'};
  let cards = [];
  let size = '';
  function track(name, source) {
    document.dispatchEvent(new CustomEvent('leavys:discovery', {detail:{name,source}}));
  }
  function indexCards() {
    cards = [...grid.querySelectorAll('.ms-card')].map((node,index) => ({
      node, index, brand:node.dataset.nfBrand, style:node.dataset.saleStyle, fit:node.dataset.saleFit,
      created:Number(node.dataset.saleCreated),
      variants:[...node.querySelectorAll('[data-sale-cents]')]
    }));
    const brands = [...new Set(cards.map(card => card.brand))].sort((a,b)=>a.localeCompare(b));
    brands.forEach(brand=>selects.brand.add(new Option(brand,brand)));
    const sizes = [...new Set(cards.flatMap(card=>card.variants.map(variant=>variant.dataset.saleUk)).filter(Boolean))].sort((a,b)=>Number(a)-Number(b));
    const extra = root.querySelector('[data-sale-extra-sizes]');
    sizes.filter(value=>!['7','8','9','10','11','12'].includes(value)).forEach(value=>{
      const button = document.createElement('button');
      button.type='button';button.dataset.saleSize=value;button.textContent=value;button.setAttribute('aria-pressed','false');
      extra.append(button);
    });
    root.querySelector('[data-sale-more]').hidden = !extra.children.length;
  }
  function loadState() {
    const params = new URL(location.href).searchParams;
    size = params.get(keys.size) || '';
    if (![...root.querySelectorAll('[data-sale-size]')].some(button=>button.dataset.saleSize===size)) size='';
    Object.entries(selects).forEach(([key,select]) => {
      const value=params.get(keys[key]) || (key==='sort'?'featured':'');
      select.value=[...select.options].some(option=>option.value===value)?value:(key==='sort'?'featured':'');
    });
    if (size && !['7','8','9','10','11','12'].includes(size)) root.querySelector('[data-sale-more]').open=true;
  }
  function saveState() {
    const url = new URL(location.href);
    const state = {size,...Object.fromEntries(Object.entries(selects).map(([key,select])=>[key,select.value]))};
    Object.entries(state).forEach(([key,value])=>{
      if (value && value!=='featured') url.searchParams.set(keys[key],value); else url.searchParams.delete(keys[key]);
    });
    url.searchParams.delete('page');
    if (url.href!==location.href) history.pushState({...history.state},'',url);
  }
  function apply(push=false) {
    const brand=selects.brand.value, style=selects.style.value, fit=selects.fit.value;
    root.querySelector('[data-sale-clear]').hidden=!(size||brand||style||fit);
    if (brand||style||fit) root.querySelector('.ms-refine-panel').open=true;
    const matchesBase=card=>(!brand||card.brand===brand)&&(!style||card.style===style)&&(!fit||card.fit===fit);
    root.querySelectorAll('[data-sale-size]').forEach(button=>{
      const value=button.dataset.saleSize;
      button.setAttribute('aria-pressed',String(value===size));
      button.disabled=Boolean(value && value!==size && !cards.some(card=>matchesBase(card)&&card.variants.some(variant=>variant.dataset.saleUk===value)));
    });
    let matches = [];
    cards.forEach(card=>{
      const variants=card.variants.filter(variant=>!size||variant.dataset.saleUk===size).sort((a,b)=>Number(a.dataset.saleCents)-Number(b.dataset.saleCents));
      const visible=matchesBase(card)&&variants.length>0;
      card.node.hidden=!visible;
      if (!visible) return;
      const variant=variants[0];
      card.price=Number(variant.dataset.saleCents);
      card.node.querySelectorAll('[data-sale-product-link]').forEach(link=>link.href=variant.href);
      card.node.querySelector('[data-sale-price]').textContent=variant.dataset.saleMoney;
      card.node.querySelector('[data-sale-was]').textContent=variant.dataset.saleWas;
      card.node.dataset.nfVariant=variant.dataset.variantId;
      card.node.dataset.nfVariantName=variant.dataset.nfVariantName;
      card.node.dataset.nfPrice=variant.dataset.nfPrice;
      card.variants.forEach(link=>link.setAttribute('aria-current',String(Boolean(size&&link.dataset.saleUk===size))));
      matches.push(card);
    });
    const sort=selects.sort.value;
    matches.sort((a,b)=>sort==='price-ascending'?a.price-b.price:sort==='price-descending'?b.price-a.price:sort==='newest'?b.created-a.created:a.index-b.index);
    matches.forEach(card=>grid.append(card.node));
    count.textContent=`${matches.length} ${root.dataset.countLabel}`;
    root.dataset.nfResultCount=String(matches.length);
    root.querySelector('[data-sale-empty]').hidden=matches.length>0;
    if (push) saveState();
    return matches.length;
  }
  async function init() {
    let next=root.querySelector('[data-sale-next]')?.href;
    const loading=root.querySelector('[data-sale-loading]');
    loading.hidden=!next;
    try {
      const visited=new Set();
      while (next) {
        if (visited.has(next)) throw new Error('Repeated page');
        visited.add(next);
        const url=new URL(next,location.href);
        url.searchParams.set('section_id',root.dataset.sectionId);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id',preview);
        const response=await fetch(url,{signal:AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('Page unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const chunk=doc.querySelector('[data-sale-grid]');
        if (!chunk) throw new Error('Missing sale grid');
        grid.append(...chunk.children);
        next=doc.querySelector('[data-sale-next]')?.getAttribute('href');
      }
      indexCards();loadState();apply();
      controls.hidden=false;
      root.querySelector('[data-sale-pagination]').hidden=true;
    } catch (_) {
      root.querySelector('[data-sale-error]').hidden=false;
    } finally {loading.hidden=true;}
  }
  controls.addEventListener('click',e=>{
    const button=e.target.closest('[data-sale-size]');
    if (button) {size=button.dataset.saleSize===size?'':button.dataset.saleSize;apply(true);track('filter_apply','mens_sale_uk_size');}
    if (e.target.closest('[data-sale-clear]')) {
      size='';Object.entries(selects).forEach(([key,select])=>select.value=key==='sort'?'featured':'');
      apply(true);track('filter_remove','mens_sale_clear');
    }
  });
  controls.addEventListener('change',e=>{
    if (!e.target.matches('select')) return;
    const matches=apply(true);
    track(e.target===selects.sort?'sort_change':'filter_apply','mens_sale');
    if (!matches) track('empty_results','mens_sale');
  });
  window.addEventListener('popstate',()=>{loadState();apply();});
  init();
})();
